import { Modal, ModalBody, Spinner } from 'reactstrap';
import BudgetIcon from '../Icons/BudgetIcon';
import ExclamationIcon from '../Icons/ExclamationIcon';
interface LockAttConfirmationModalProps {
  modal: boolean;
  closeHandler: () => void;
  type: string;
  isLoading?: boolean;
  submitHandler: () => void;
}

const LockAttConfirmationModal = ({
  modal,
  closeHandler,
  type,
  isLoading,
  submitHandler,
}: LockAttConfirmationModalProps) => {
  const handleSubmit = () => {
    submitHandler();
  };

  const getMessage = () => {
    if (type === 'createSalary') {
      return 'Are you sure you want to create the salary record for this site?';
    }
    return 'Please ensure all attendance records are accurate before locking, as records cannot be modified once locked.';
  };

  const getConfirmLabel = () => {
    return type === 'createSalary' ? 'Create' : 'Yes';
  };

  return (
    <Modal isOpen={modal} toggle={closeHandler} centered>
      <ModalBody className="text-center">
        <div className="d-flex flex-column justify-items-center align-items-center gap-4">
          <span className="icon">
            {type === 'createSalary' ? <BudgetIcon /> : <ExclamationIcon />}
          </span>
          <p className="mb-4">{getMessage()}</p>
          <div className="row m-0 w-100">
            <div className="col-12 col-md-6 ps-0 pe-3">
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={closeHandler}
              >
                Cancel
              </button>
            </div>
            <div className="col-12 col-md-6 pe-0 ps-3">
              <button
                className="btn btn-danger w-100"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? <Spinner color="light" /> : getConfirmLabel()}
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default LockAttConfirmationModal;
